import "../styleSheets/contactStyle.css";
export function ContactUs(){
    return (
        <footer className="contact_wrapper">
            <h2>Contact Us</h2>
            <ul className="contact_list">
                <li>
                    <strong>Email:</strong>{" "}
                    <a href="mailto:tluckenstunts@me.com">tluckenstunts@me.com</a>
                </li>
                <li>
                    <strong>Phone:</strong>{" "}
                    <a href="tel:+447785595792">+44 7785 595792</a>
                </li>
            </ul>
        </footer>
    );
}

